<template>
  <div id="app">
    <commonhead :active_menu="5" :callback="authcallback" />
    <div class="user_course_detail my_style">
      <div class="content_wrap">
        <div class="step_title">预习</div>
        <div class="course_text" v-html="preview"></div>
        <div class="step_title">{{ isReview ? "查看回放" : "进入教室" }}<span>（点击中间播放按钮）</span></div>
        <div class="course_video">
          <!-- <iframe frameborder=0 height="100%" width="100%" :src="url"></iframe> -->
          <div class="course_play" @click="enterroom"></div>
        </div>
        <div class="step_title" v-if="isReview">复习</div>
        <div class="course_text" v-html="review" v-if="isReview"></div>
      </div>
      <!--公共底部-->
      <commonfoot />
      <!--公共底部-->
    </div>
  </div>
</template>

<script>
import { common } from "../../../common.js";
import commonhead from "../common/common_head.vue";
import commonfoot from "../common/common_foot.vue";
export default {
  name: "app",
  components: {
    commonhead,
    commonfoot,
  },
  data: function () {
    return {
      resData: "",
      preview: "",
      review: "",
      isReview: false,
      url: "",
    };
  },
  mounted: function () {
    if (this.$route.query.id) {
      this.getList(this.$route.query.id);
    }
  },
  methods: {
    getList(id) {
      let self = this;
      common.requestFun(
        self,
        "get",
        "/student/courses",
        {
          reservation_id: id,
        },
        (res) => {
          if (res.data.code == 200) {
            const resData = res.data.data.list[0];
            self.resData = resData;
            const nowtime = new Date().getTime() / 1000;
            const status = resData.status;
            const { start, end } = resData.course;
            const course_id = resData.id;
            const is_paid = resData.order.is_paid == 1;
            if (status == 2 || nowtime > end) {
              self.isReview = true;
            }
            if (status == 1 && start < nowtime && nowtime < end) {
              self.checkVideo(course_id, 1);
            } else if (status == 1 && nowtime < start && is_paid) {
              self.enter_now(course_id);
            } else if (this.isReview) {
              self.checkVideo(course_id, 0);
            }
          }
        }
      );
    },
    authcallback(isLogin) {
      if (!isLogin) {
        this.$message({
          message: "请登录",
          type: "error",
          center: true,
        });
        this.$router.push("./");
      }
    },
    checkVideo(id, type) {
      let self = this;
      common.requestFun(
        self,
        "get",
        type == 0
          ? "student/classroom/record/" + id
          : "student/classroom/" + id,
        {},
        (res) => {
          if (res.data.code == 200) {
            self.url =
              res.data.data.url || res.data.data.recordlist[0].https_playpath;
          } else {
            if (res.data.msg) {
              self.$message({
                message: res.data.msg,
                type: "error",
                center: true,
              });
            }
          }
        }
      );
    },
    enter_now(id) {
      let self = this;
      common.requestFun(
        self,
        "get",
        "/student/classroom/" + id,
        {},
        (res_1) => {
          if (res_1.data.code == 200) {
            if (res_1.data.data) {
              if (res_1.data.data.url) {
                self.url = res_1.data.data.url;
              }
            }
          }
        }
      );
    },
    enterroom() {
      if (!this.url) {
        this.$message({
          message: '课堂不存在',
          type: "error",
          center: true,
        });
      }else{
        window.open(this.url, "_blank");
      }
    },
  },
};
</script>
<style scoped src="./user_course_detail.css"></style>
